import { timelineItemDefaultValue } from '@gantt/constants'

export const getBarDefaultValue = () => {
  return structuredClone(timelineItemDefaultValue)
}
